import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslate } from 'react-admin';
import { TREATMENT_METADATA_AVATAR_TYPE_NAME, DISORDER_METADATA_AVATAR_TYPE_NAME } from '@/utils/CONST';

interface ExportDisorderTreatmentHeaderProps {
    metadataAvatarTypeName?: string;
}

const ExportDisorderTreatmentHeader = ({ metadataAvatarTypeName }: ExportDisorderTreatmentHeaderProps) => {
    const translate = useTranslate();

    const isTreatment = metadataAvatarTypeName === TREATMENT_METADATA_AVATAR_TYPE_NAME;
    const isDisorder = metadataAvatarTypeName === DISORDER_METADATA_AVATAR_TYPE_NAME;

    const title = isTreatment
        ? translate('disorder.export.title_treatment')
        : isDisorder
          ? translate('disorder.export.title_disorder')
          : translate('disorder.export.title');

    return (
        <Box
            sx={{
                display: 'grid',
                justifyContent: 'center',
                justifyItems: 'center',
                gap: 1,
            }}
        >
            <Box
                sx={{
                    height: 45,
                }}
                component='img'
                src={'/images/big-logo-white.png'}
                alt={'mainLogo'}
            />

            <Typography
                variant='h4'
                sx={{
                    fontWeight: 700,
                    color: 'text.primary',
                    letterSpacing: '0.3px',
                }}
            >
                {title}
            </Typography>

            <Typography
                variant='body1'
                color='text.secondary'
                sx={{
                    fontSize: '0.95rem',
                }}
            >
                {translate('disorder.export.subtitle')}
            </Typography>
        </Box>
    );
};

export default ExportDisorderTreatmentHeader;

